import {
    useCallback, useContext, useEffect
} from 'react';
import _ from 'lodash';
import { events } from 'gw-platform-events-js';
import CommonConstants from 'sg-common-constants';
import SgSubQuestionsContext from './SgSubQuestionsContext';
import SgSessionStorageService from '../sg-session-storage';

function useSgHandleSubQuestions({
    updateModel,
    updateInvalidSubQuestions,
    modelVM,
    paths // string array with paths to check
}) {
    const {
        isComponentVisible,
    } = useContext(SgSubQuestionsContext);

    const filterInvalidFields = useCallback((pathString) => {
        const invalidQuestionArray = SgSessionStorageService.getItem(SgSessionStorageService.KEY.INVALID_SUB_QUESTIONS);
        const filteredSubQuestions = _.filter(invalidQuestionArray, (subQuestion) => {
            return subQuestion !== pathString;
        });
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.INVALID_SUB_QUESTIONS, filteredSubQuestions);
        if (updateInvalidSubQuestions) {
            updateInvalidSubQuestions(filteredSubQuestions);
        }
    }, [updateInvalidSubQuestions]);

    paths.forEach((path) => {
        const pathString = path.path || path;
        const emptyValue = path.emptyValue || undefined;
        const preventClearing = path.preventClearing || false;
        const currentModel = _.get(modelVM, pathString);
        const isRequired = !_.isNil(path.required) ? path.required : currentModel && currentModel.aspects && currentModel.aspects.required;
        const isValid = currentModel && currentModel.aspects && currentModel.aspects.subtreeValid;

        // fields array is static - hook will be used properly
        /* eslint-disable-next-line */
        useEffect(() => {
            if (isComponentVisible !== false) {
                if (!isRequired) {
                    if (_.get(modelVM, pathString) !== undefined && !preventClearing) {
                        _.set(modelVM, `${pathString}.value`, emptyValue);
                        updateModel(modelVM);
                    }
                    filterInvalidFields(pathString);
                }
            }
        }, [isRequired, isComponentVisible]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (isValid && isComponentVisible !== false) {
                filterInvalidFields(pathString);
            }
        }, [isValid, isComponentVisible]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            const handleShowValidationEvent = () => {
                const invalidQuestionArray = SgSessionStorageService.getItem(SgSessionStorageService.KEY.INVALID_SUB_QUESTIONS);
                if (!invalidQuestionArray.includes(pathString) && isRequired && !isValid && path.visible !== false) {
                    invalidQuestionArray.push(pathString);
                }
                if (isValid) {
                    filterInvalidFields(pathString);
                } else {
                    SgSessionStorageService.setItem(SgSessionStorageService.KEY.INVALID_SUB_QUESTIONS, invalidQuestionArray);
                    if (updateInvalidSubQuestions) {
                        updateInvalidSubQuestions(invalidQuestionArray);
                    }
                }
            };
            if (isComponentVisible !== false) {
                events.on(CommonConstants.SHOW_VALIDATION_ERROR_EVENT, handleShowValidationEvent);
            }
            return () => {
                events.removeListener(CommonConstants.SHOW_VALIDATION_ERROR_EVENT, handleShowValidationEvent);
            };
        }, [isComponentVisible, isRequired, isValid, path.visible]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            return () => {
                filterInvalidFields(pathString);
            };
        }, []);
    });
}

export default useSgHandleSubQuestions;
